import React from "react";

const SectionHeading = ({ overline, title, subtitle, align = "left", testId }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`} data-testid={testId}>
    {overline && <p className="overline mb-4">{overline}</p>}
    <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-medium leading-[1.05] tracking-tight text-[#3B2A1A]">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-5 text-base sm:text-lg leading-relaxed text-[#5C4A3A] font-light max-w-2xl">
        {subtitle}
      </p>
    )}
  </div>
);

export default SectionHeading;
